import { DateTime } from 'luxon'

export const formatLastUpdatedForSubmissionStatus = (
	timeString?: string | null
) => {
	if (!timeString) {
		return ''
	}

	return DateTime.fromISO(timeString).toFormat('M/dd @ h:mm a')
}

export const toTitleCase = (input: string): string => {
	return input
		.split(/[_ ]+/)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ')
}

export const getEverplansTierText = (tier?: string | null): string => {
	switch (tier) {
		case 'freemium':
			return 'Basic'
		case 'premium':
			return 'Lifetime'
		default:
			return ''
	}
}
